export const logoSizes = {
  mobile: { width: 295, height: 155 },
  tablet: { width: 500, height: 262 },
  desktop: { width: 550, height: 288 },
};
